import type { VatRatePercent } from '../types/dealerFundStatementPeriod.types';

const LABELS: Record<VatRatePercent, string> = {
    '0.0000': '0%',
    '5.0000': '5%',
    '20.0000': '20%',
};

export const vatRateLabel = (percent: VatRatePercent): string => LABELS[percent];
